module.exports = "/images/regel-1.jpg?f50ec4413eb593ade5e544f0541cebb0";